import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import {
  Button,
  FormatText,
  FormDatePicker,
  FormInput,
  FormSubmitButton,
  FormTextArea,
  MasterDetailForm,
  Widget,
} from '@digital/ui';
import { UploadFile } from '@app/components';
import { hasPermission } from '@app/helpers/permissions';

import { substituirArquivoAutorizacao } from '@app/api/autorizacaoPagamento/autorizacao';

import './modal.css';
import CurrencyInput from '@app/components/CurrencyInput';

export interface PropsModalSubstituirArquivo {
  arquivoAutorizacaoId: string;
  setUpdate: any;
}

const ModalSubstituirArquivo = (props: PropsModalSubstituirArquivo) => {
  const { arquivoAutorizacaoId, setUpdate } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [fileDocumento] = useState([]);
  const [disableButton, setDisableButton] = useState(false);

  const handleSubmit = values => {
    setDisableButton(true);
    substituirArquivoAutorizacao(values, arquivoAutorizacaoId).then(data => {
      if (data) {
        if (data.valid) {
          setExibirModal(false);
          setUpdate(null);
          setUpdate(true);
        }
        setDisableButton(false);
      }
    });
  };

  return (
    <>
      <Tooltip title="Substituir Arquivo Autorização">
        <Button
          onClick={() => {
            setExibirModal(true);
            // CarregarDados();
          }}
          icon="files-add_file"
          name="btnSubstituirArquivoAutorizacao"
        />
      </Tooltip>
      <Modal
        title="Substituir Arquivo Autorização"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModalSubstituirArquivo"
          onSubmit={handleSubmit}
          actions={[
            <Button
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton
              noIcon={true}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR']) || disableButton}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormInput name="documentoCobrancaNumero" label="Número do Documento" span={4} />
            <FormDatePicker name="dataEmissao" label="Data de Emissão" format="DD/MM/YYYY" span={4} />
            <CurrencyInput name="valor" label="Valor" span={4} />
            <FormTextArea name="justificativa" label="Justificativa" span={12} rows={4} maxLength={2000} />
            <UploadFile
              nameFormData={'fileDocumento'}
              label={'Arquivo Autorização'}
              hasFile={true}
              url={'fileDocumento' + '&fileName=' + fileDocumento}
            />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalSubstituirArquivo;
